// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import utils from '@/utils/utils'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import App from './App'
import filters from './filters'
import router from './router'
import store from './store'
import './style/index.less'

Vue.use(mavonEditor)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueClipboard)
filters(Vue)
ElementUI.Dialog.props.lockScroll.default = false;
// Vue.use(ElementUI, {
// 	size: "small",
// 	menuType: "text"
// });
router.beforeEach((to, from, next) => {
	let domain = location.href.split('#')[0]
	console.log(to)
	if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) && domain !== 'http://localhost:8089/') {
		if (to.path === '/login') {
			window.location.href = process.env.MOBILE_URL + '/login'
		} else if (to.path === '/home') {
			window.location.href = process.env.MOBILE_URL + '/personal'
		} else if (to.path === '/finance/createOrder') {
			window.location.href = process.env.MOBILE_URL + '/createOrder?id=' + to.query.id + '&priceId=' + to.query.priceId
		} else if (to.path === '/finance/payOrder') {
			window.location.href = process.env.MOBILE_URL + '/payOrder?id=' + to.query.id
		}
		// window.location.href = process.env.MOBILE_URL
	}
	if (to.meta.requireAuth) {
		store.commit('updataActiveIndex', to.path)
		// console.log(localStorage.getItem('token'))
		let token = utils.getStorage('token')
		if (token && token.length > 10) {
			if (to.meta.title) {
				document.title = to.meta.title + ' - 数脉API'
			} else {
				document.title = '数脉API'
			}
			next()
		} else {
			next({
				path: 'login'
			})
		}
	} else {
		if (to.meta.title) {
			document.title = to.meta.title + ' - 数脉API'
		} else {
			document.title = '数脉API'
		}
		next()
	}
})
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js